import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['contactSalesMqlClicked', 'variant_trial_paywall'] as const;

export const abTestEvents = getMappedEvents([...EVENTS]);
